import { Params } from './ExternalAutoForm.types';

export const getQueryParams = (): Params => {
  const params: Params = {};
  new URLSearchParams(window.location.search).forEach((value, key) => {
    params[key] = value;
  });
  return params;
};
